export default __webpack_public_path__ + "static/indoor-02167e944345cdb16d836c8de9de2638.png";